
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { getCampsiteCategoriesPresenter } from '~/apps/categories/presenter-json/CampsiteCategoriesUpdaterJson'
import { SearchFilters } from '~/apps/search/schemas'
import CATEGORY_MAP from '~/json/catRoot.json'
import { ensureArray } from '~/utility/array'
import { CampsiteCategory } from '~/utility/types/CampsiteCategory'

@Component
export default class SearchSummaryBarDetailsCategories extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop({ required: false })
    slug?: string

  ensureArray(ar) {
    return ensureArray(ar)
  }

  get categoriesSelectedInSearch(): CampsiteCategory[] | undefined {
    const searchCategories = this.searchFilters.categoryIds || []
    if (searchCategories.length) {
      const categoriesPresenter = getCampsiteCategoriesPresenter(
        this.$route.params.lang || 'en-gb',
      )
      return categoriesPresenter.list.filter((c) =>
        searchCategories.includes(c.id),
      )
    }
    return undefined
  }

  get isAllCategoriesSelected() {
    const categoryIds = Object.keys(CATEGORY_MAP)
    return this.categoriesSelectedInSearch
      ? this.categoriesSelectedInSearch.length === categoryIds.length
      : false
  }
}
